import { ImpactPageProps } from './ImpactPage.types'
import { PageWrapper } from '@otomoro/components/layout/PageWrapper'
import { FlexibleContent } from '@otomoro/components/shared/FlexibleContent'
import { Headline } from '@otomoro/components/shared/Headline'
import { SanityImage } from '@otomoro/components/shared/SanityImage'

type SanityBlockType = { _type: string }

export default function ImpactPage({ data }: ImpactPageProps) {
	if (!data) {
		return (
			<div className="text-center">
				Please start editing your Impact document to see the preview!
			</div>
		)
	}

	const blocks = data.flexibleContent as any
	const lastType = blocks[blocks.length - 1]._type as string

	return (
		<PageWrapper
			noPbMobile={lastType === 'promotionalCard'}
			noPb={lastType === 'promotionalCard'}
		>
			<Headline size="large" border headlineText={data.headline} subheadline={data.subHeadline}>
				<SanityImage
					figureClass="px-2 mt-5 lg:px-4 lg:mt-7 aspect-square lg:aspect-auto lg:h-[67.5rem]"
					className="h-full object-cover rounded-l"
					image={data?.heroImage}
					alt=""
				/>
			
			</Headline>
			<FlexibleContent blocks={data?.flexibleContent as any} />
		</PageWrapper>
	)
}
